<template>
    <div class="main-container">
        <div class="container__alert">
          <div class="alert alert__connexion" v-if="loadingConnection">
              <div class="alert__header">
                  <div class="alert__title">
                      <p>{{translationArray.connecting}}</p>
                  </div>
                  <hr>
              </div>
              <div class="alert__body">
                  <div class="alert__image">
                      <div class="loading">
                          <div class="animateSpin">
                              <div class="loader">
                              </div>
                          </div>
                      </div>                         
                  </div>
              </div>
          </div>
        </div>
        <header class="headerBlue">
            <svg class="waves" width="455" height="455" viewBox="0 0 455 455" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="227.949" cy="227.949" r="124.244" stroke="#3CB5A8"/>
                <circle cx="227.949" cy="227.948" r="173.603" stroke="#3CB5A8" stroke-opacity="0.4"/>
                <circle cx="227.5" cy="227.5" r="227" stroke="#3CB5A8" stroke-opacity="0.1"/>
            </svg>
            <a @click="historyBack()" class="btnBack">
                <span class="btnBack__svg">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="arrow_back_24px">
                    <path id="icon/navigation/arrow_back_24px" d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z" fill="#3CB5A8"/>
                    </g>
                    </svg>
                </span>
            </a>
            <div class="containerTitle">
                <h1>{{translationArray.connection}}</h1>
                <p><span>{{translationArray.on}}</span><span>{{this.$senzuAuth.nameClient}}</span></p>
            </div>

            <div class="containerPartner">
                <div class="partnerBox partnerBox__Left" v-if="!isSenzuApp">
                    <img v-if="this.$senzuAuth.hasImageClient == 'false'" src="../../static/img/logo.png" :alt="'image_' + this.$senzuAuth.nameClient">
                    <img v-else :src="this.$senzuAuth.urlImageClient" :alt="'image_' + this.$senzuAuth.nameClient">
                </div>
                <div class="partnerSeparation" v-if="!isSenzuApp">
                    <svg width="34" height="54" viewBox="0 0 34 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M33.0607 13.0607C33.6464 12.4749 33.6464 11.5251 33.0607 10.9393L23.5147 1.3934C22.9289 0.807611 21.9792 0.807611 21.3934 1.3934C20.8076 1.97919 20.8076 2.92893 21.3934 3.51472L29.8787 12L21.3934 20.4853C20.8076 21.0711 20.8076 22.0208 21.3934 22.6066C21.9792 23.1924 22.9289 23.1924 23.5147 22.6066L33.0607 13.0607ZM1 13.5H32V10.5H1V13.5Z" fill="#EEEEEE"/>
                        <path d="M0.939339 40.9393C0.353554 41.5251 0.353554 42.4749 0.939339 43.0607L10.4853 52.6066C11.0711 53.1924 12.0208 53.1924 12.6066 52.6066C13.1924 52.0208 13.1924 51.0711 12.6066 50.4853L4.12132 42L12.6066 33.5147C13.1924 32.9289 13.1924 31.9792 12.6066 31.3934C12.0208 30.8076 11.0711 30.8076 10.4853 31.3934L0.939339 40.9393ZM33 40.5H2V43.5H33V40.5Z" fill="#EEEEEE"/>
                    </svg>                    
                </div>
                <div class=" partnerBox partnerBox__Right">
                    <img src="../../static/img/senzu.png" alt="">
                </div>  
            </div>
            <div class="containerDescription">
                <p class="information__title__computer">{{translationArray.accept_roles}}</p>

                <p class="containerDescription__p">{{translationArray.accept_roles_connect}}</p>
            </div>
        </header>
        <section class="bodyBlue body__role">
            <div class="userBox opacity-1">
                <div class="contentImgUser">
                    <div class="imgUser">
                        <img v-if="this.$senzuAuth.urlImage == 'false'" src="../../static/img/default.png" alt="">
                        <img v-else :src="this.$senzuAuth.urlImage" alt="">
                    </div>
                </div>
                <div class="contentInfoUser">
                    <p><span class="contentInfoUser__name">{{this.$senzuAuth.firstname}} {{this.$senzuAuth.lastname}}</span></p>
                    <p><span class="contentInfoUser__description"></span></p>
                </div>
            </div>
            <p class="bodyBlue--title">
                {{translationArray.accept_roles_continue}}
            </p>
            <div class="container__form" :style="[ isMobile ? {width: '100%'}: {width: '80%'}]">
                <form @submit="checkRoles" class="roleForm" method="POST">
                    <div class="roleBox roleBox-1" v-for="(value, key, index)  in arrayScope" :key="index">
                        <div class="roleBoxContent">
                            <div class="roleBoxHeader">
                                <p class="roleBox__title">{{key}}</p>
                                <div class="switch">
                                    <label class="switch">
                                        <input class="findOrphanRecords" type="checkbox" checked v-model="arrayScope[key]" :id="key">
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            <hr>
                            <div class="roleBox__description">
                                <p>{{key}}</p>
                            </div>
                        </div>
                    </div>               
                    <input class="submit submit--margin submit--width" type="submit" value="Accepter les rôles">
                </form>
            </div>
        </section>
        <footer>
        </footer>
    </div>
</template>

<script>
import {translate} from '../../static/js/translate';

export default {
  name: 'AskRoles',
  mounted() {
    this.translationArray = translate(navigator.language.substr(0, 2));

    let clientId = typeof(this.$route.query.client_id) !== "undefined" ? this.$route.query.client_id : null;
    if(clientId <= 8 || typeof(clientId) == 'undefined') {
        this.isSenzuApp = true;
    }

    let params = "?scope=" + this.$route.query.scope + "&id_user=" + this.user.id + "&client_id=" + this.$route.query.client_id;
    
    fetch(`${this.$origin}/roles${params}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'CSRF-Token': this.csrfToken
            },
        }).then(result => result.json())
        .then(data => {
            this.scope = data.scope;
            this.createArrayRoles();
        }
    );

    window.addEventListener("resize", this.handleResize);
    this.handleResize();

    this.$senzuAuth.nameClient = localStorage.getItem("name_client");
    this.$senzuAuth.urlImageClient = localStorage.getItem("url_image_client");
    this.$senzuAuth.hasImageClient = localStorage.getItem("has_image_client");

    this.$senzuAuth.firstname = localStorage.getItem("firstname");
    this.$senzuAuth.lastname = localStorage.getItem("lastname");
    this.$senzuAuth.idUser = localStorage.getItem("idUser");
    this.$senzuAuth.urlImage = localStorage.getItem("urlImage");

    
  },
  data () {
    return {
        idUser: this.$route.query.id_user,
        user: JSON.parse(localStorage.getItem("user")),
        isSenzuApp: false,
        isDesktop: false,
        isMobile: true,
        scope: null,
        arrayScope: null,
        loadingConnection: false,
        translationArray: {},
        csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    }
  },
  methods: {
      handleResize: function() {
          if(window.innerWidth <= 1120) {
              this.isMobile = true;
              this.isDesktop = false;
          } else {
              this.isMobile = false;
              this.isDesktop = true;
          }
      },
      historyBack: function() {
          this.$router.replace({name: 'Authorize', query: {
            client_id: this.$route.query.client_id, 
            redirect_uri: this.$route.query.redirect_uri,
            response_type: this.$route.query.response_type,
            scope: this.$route.query.scope,
            code_challenge: this.$route.query.code_challenge,
            code_challenge_method: this.$route.query.code_challenge_method,
            state: this.$route.query.state,
            }
        });
      },
      checkRoles: function(e) {
        e.preventDefault();

        let clientId = typeof(this.$route.query.client_id) !== "undefined" ? this.$route.query.client_id : null;
        let responseType = typeof(this.$route.query.response_type) !== "undefined" ? this.$route.query.response_type : null;
        let redirectUri = typeof(this.$route.query.redirect_uri) !== "undefined" ? this.$route.query.redirect_uri : null;
        //let scope = typeof(this.$route.query.scope) !== "undefined" ? this.$route.query.scope : null;
        let codeChallenge = typeof(this.$route.query.code_challenge) !== "undefined" ? this.$route.query.code_challenge : null;
        let codeChallengeMethod = typeof(this.$route.query.code_challenge_method) !== "undefined" ? this.$route.query.code_challenge_method : null;
        let state = typeof(this.$route.query.state) !== "undefined" ? this.$route.query.state : null;

        let params = "?client_id="+ clientId + "&response_type=" + responseType + "&redirect_uri=" + redirectUri + "&scope=" 
          + this.scope + "&code_challenge=" + codeChallenge + "&code_challenge_method=" + codeChallengeMethod + "&state=" + state;

        fetch(`${this.$origin}/roles${params}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'CSRF-Token': this.csrfToken
                },
            body: JSON.stringify({'roles': this.arrayScope, 'id_user': this.user.id})
        }).then(result => result.json())
        .then(data => {
            if(data.redirect_uri != null) {
                this.loadingConnection = true;
                localStorage.setItem("last_page", "AskRoles");
                window.location.replace(data.redirect_uri);
            }
        });
      }, 
      createArrayRoles: function() {
        this.arrayScope = this.scope.split(' ');
        let roles = {};
        this.arrayScope.forEach(function(role, key) {
            if(role != "") {
                roles[role] = true;
            }
        });
        this.arrayScope = {};
        Object.assign(this.arrayScope, roles);
      }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/AskRoles.vue